const productJsonLd = ({data})=>{
    let photos = [];
    if(data?.fotos?.length) {
        data.fotos.map(i => {
            photos.push(i.url);
        });
    }
    const structuredData = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": (data?.nombre) ? data.nombre : '',
        "image": photos,
        "description": (data?.descripciontxt) ? data.descripciontxt : '',
        "sku": (data?.slug) ? data.slug : '',
        "mpn": (data?.slug) ? data.slug : '',
        "brand": {
            "@type": "Brand",
            "name": "Florería Detalles y Caprichos"
        },
        "review": {
            "@type": "Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4",
                "bestRating": "5"
            },
            "author": {
                "@type": "Person",
                "name": "Florería Detalles y Caprichos"
            }
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.5",
            "reviewCount": "89"
        },
        "offers": {
            "@type": "Offer",
            "url": `https://arreglos-florales.com/producto/${data.uri}`,
            "priceCurrency": "MXN",
            "price": (data?.price?.precio) ? data.price.precio : 0,
            "priceValidUntil": `${new Date().getFullYear()}-12-31`,
            "itemCondition": "https://schema.org/UsedCondition",
            "availability": "https://schema.org/InStock"
        }
    };
    return <>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
    </>
};

export default productJsonLd;